import { getTypeForNode } from './WeaverUtils';

class ColorService {
  stringToPastelHex(str) {
    if (!str || typeof str !== 'string') {
      return '#EEEEEE';
    }
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const salt = 2654435761;
    hash = (hash * salt) >>> 0;

    const steps = 24;
    const hue = (hash % steps) * (360 / steps);

    const saturation = 60;
    const lightness = 80;

    function hslToRgb(h, s, l) {
      s /= 100;
      l /= 100;
      const k = n => (n + h / 30) % 12;
      const a = s * Math.min(l, 1 - l);
      const f = n =>
        l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

      return [
        Math.round(255 * f(0)),
        Math.round(255 * f(8)),
        Math.round(255 * f(4))
      ];
    }

    const [r, g, b] = hslToRgb(hue, saturation, lightness);
    return `#${[r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')}`;
  }

  getColorForType(type) {
    return this.stringToPastelHex(type);
  }

  getColorForNode(node) {
    return this.stringToPastelHex(getTypeForNode(node));
  }
}

export default new ColorService();